module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1515-878a0d1cc6429e23c9928401036407cc.png";